import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#030E1A",
      "fill-rule": "evenodd",
      d: "M8.167 7.667a.667.667 0 0 1-1.334 0V5a.667.667 0 0 1 1.334 0zM7.5 10.333A.667.667 0 1 1 7.5 9a.667.667 0 0 1 0 1.333m7.04-.464-5.114-8.48C9.026.728 8.306.333 7.5.333c-.807 0-1.527.395-1.926 1.056L.459 9.87a1.98 1.98 0 0 0-.03 2.022C.815 12.575 1.565 13 2.385 13h10.23c.82 0 1.57-.425 1.956-1.11a1.98 1.98 0 0 0-.03-2.021",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }